module.exports = __webpack_public_path__ + "assets/img/brandLogo1.23241c53.jpg";